<div class="modal in" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    {{'COMMON.Login' | translateHs }}
                </h4>
                <button type="button" (click)="close()" class="btn-close" data-dismiss="modal"
                    [attr.aria-label]="'COMMON.close' | translateHs "></button>
            </div>
            <div class="modal-body" style="max-height:600px; height: 35em; overflow-y:auto">
                <iframe [src]="url" style="width:100%; height:100%;border:0"></iframe>
            </div>
        </div>
    </div>
</div>